import '../layout/Box.js';
import { Stack } from '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import styled from 'styled-components';
var TableRow = styled(Stack)({
  boxSizing: "border-box"
});
TableRow.defaultProps = {
  width: "100%",
  spacing: "8px"
};
export { TableRow };